import Model from "../Model";

class ComercialsDivisionsdetail extends Model{

    buildUrl ({ param }) {
        return ['allzonebydivisionview/getdimensionbyregion', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialsDivisionsdetail;